import React from 'react';

interface EmptyStateProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Visual icon area — can be an emoji, SVG, or any React node. */
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  testid?: string;
}

/** Atlassian-flavoured empty state with a soft hairline border. */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
  className = '',
  testid,
}) => (
  <div
    data-testid={testid}
    className={
      'bg-white border border-dashed border-slate-300 rounded-xl ' +
      'flex flex-col items-center text-center py-12 px-6 ' + className
    }
  >
    {icon && (
      <div className="mb-3 text-slate-400 text-3xl" aria-hidden>
        {icon}
      </div>
    )}
    <h3 className="text-base font-semibold text-slate-900">{title}</h3>
    {description && (
      <p className="text-sm text-slate-600 mt-1.5 max-w-md">{description}</p>
    )}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export default EmptyState;
